import _ from 'lodash';
//constants
import { field, validationProps, validationTypes } from './types';
import { EMAIL_REGEX, PHONE_REGEX, WEBSITE_REGEX, isValidCityName } from 'constants/global.constants';

export function loopValidateTypes(
	name: string,
	fieldValidations: { [key in validationTypes]?: any }[] = [],
	value: string = '',
	validateData?: Record<validationTypes, string | number | boolean>
) {
	let isValid = { name: name, valid: true, errorText: '', errorValue: '' };
	fieldValidations.forEach((type) => {
		switch (type) {
			case validationTypes.requierd:
				if (value === '' || _.isNil(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.required',
					};
				}
				break;
			case validationTypes.checked:
				if (isValid.valid && !value) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.required',
					};
				}
				break;
			case validationTypes.lettersOnly:
				if (value && value !== '') {
					let matchLetters = /^([a-z]|\s)+$/i;
					isValid = _.isNil(value.match(matchLetters))
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.alphabet',
						  }
						: isValid;
				}
				break;
			case validationTypes.cityName:
				if (isValid.valid && value && value !== '') {
					isValid = !isValidCityName(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.city',
						  }
						: isValid;
				}
				break;
			case validationTypes.hebrewLettersOnly:
				if (value && value !== '') {
					const matchLetters = /^[\p{Script=Hebrew}\s]+$/u;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.hebrew_letters',
						  }
						: isValid;
				}
				break;
			case validationTypes.englishAndHebrewLettersOnly:
				if (value && value !== '') {
					const matchLetters = /^[\u0590-\u05FF\s|A-Za-z]*$/u;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.lettersOnly',
						  }
						: isValid;
				}
				break;
			case validationTypes.email:
				if (!EMAIL_REGEX.test(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.email',
					};
				}
				break;
			case validationTypes.website:
				if (!WEBSITE_REGEX.test(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.not_match',
					};
				}
				break;
			case validationTypes.phone:
				if (!PHONE_REGEX.test(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.phone',
					};
				}
				break;
			case validationTypes.match:
				if (value === 'false') {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.not_match',
					};
				}
				break;
			case validationTypes.id:
				const intValue = parseInt(value);
				if (isNaN(intValue) || intValue < 1) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.required',
					};
				}
				break;
			case validationTypes.minAmount:
				const amount = parseFloat(value);
				if (isValid.valid && _.has(validateData, validationTypes.minAmount)) {
					if (isNaN(amount) || amount < Number(_.get(validateData, validationTypes.minAmount))) {
						isValid = {
							...isValid,
							valid: false,
							errorText: 'validations.errors.minimum_amount',
							errorValue: String(_.get(validateData, validationTypes.minAmount)),
						};
					}
				}
				break;
			case validationTypes.maxAmount:
				const amountMax = parseFloat(value);
				if (isValid.valid && _.has(validateData, validationTypes.maxAmount)) {
					if (isNaN(amountMax) || amountMax > Number(_.get(validateData, validationTypes.maxAmount))) {
						isValid = {
							...isValid,
							valid: false,
							errorText: 'validations.errors.maximum_amount',
							errorValue: String(_.get(validateData, validationTypes.maxAmount)),
						};
					}
				}
				break;
			case validationTypes.min3Chars:
				if (isValid.valid && value.length < 3) {
					isValid = { ...isValid, valid: false, errorText: 'validations.errors.minimum_3_chars' };
				}
				break;
			case validationTypes.min5Chars:
				if (isValid.valid && value.length < 5) {
					isValid = { ...isValid, valid: false, errorText: 'validations.errors.minimum_5_chars' };
				}
				break;
			case validationTypes.englishAndDigits:
				if (value && value !== '') {
					const matchLetters = /^([a-zA-Z]|\s|[0-9])+$/i;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.english_and_digits',
						  }
						: isValid;
				}
				break;
			case validationTypes.englishAndHebrewLettersAndDigits:
				if (value && value !== '') {
					//const matchLetters = /^([a-zA-Z]|\s|[0-9])+$/i;
					const matchLetters = /^[\u0590-\u05FF\s|A-Za-z0-9]*$/u;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.alphabet_and_digits',
						  }
						: isValid;
				}
				break;
			case validationTypes.digits:
				if (isValid.valid && value && value !== '') {
					const matchLetters = /^[0-9]+$/u;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.digits',
						  }
						: isValid;
				}
				break;
			case validationTypes.float:
				if (isValid.valid && !isFloat(value)) {
					isValid = {
						...isValid,
						valid: false,
						errorText: 'validations.errors.digits',
						errorValue: String(_.get(validateData, validationTypes.minAmount)),
					};
				}
				break;

			case validationTypes.custom:
				if (isValid.valid) {
					const custom = _.get(type, validationTypes.custom);
					if (_.isFunction(custom?.function) && !custom?.function(value)) {
						isValid = {
							...isValid,
							valid: false,
							errorText: custom.errorText,
						};
					}
				}
				break;
			case validationTypes.hebrewLettersSpecialChars:
				if (value && value !== '') {
					const matchLetters = /^[\u0590-\u05FF\s|0-9\\(\\)-\\"\\']*$/u;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.hebrewLettersSpecialChars',
						  }
						: isValid;
				}
				break;
			case validationTypes.englishLettersSpecialChars:
				if (value && value !== '') {
					const matchLetters = /^[a-z|A-Z|0-9|\s|\\(|\\)|\-|\\_|&|:|\.|\\"|\\']*$/u;
					isValid = !matchLetters.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.englishLettersSpecialChars',
						  }
						: isValid;
				}
				break;
			case validationTypes.noDecimalAllowed:
				if (value && value !== '') {
					const integerRegex = /^-?\d+$/;
					isValid = !integerRegex.test(value)
						? {
								...isValid,
								valid: false,
								errorText: 'validations.errors.noDecimalsAllowed',
						  }
						: isValid;
				}
				break;
			case validationTypes.forbiddenCurrency:
				isValid = {
					...isValid,
					valid: false,
					errorText: 'validations.errors.forbiddenCurrency',
				};
				break;
		}
	});
	return isValid;
}

export function validateFields(
	fieldsValidation: { [key: string]: validationTypes[] },
	data: { [key: string]: string },
	validateData?: Record<validationTypes, string | number | boolean>
) {
	let invalidsFields: { [key: string]: validationProps } = {};
	_.keys(fieldsValidation).forEach((name) => {
		if (_.has(data, name)) {
			const isValid = loopValidateTypes(name, fieldsValidation[name], data[name], validateData);
			if (!isValid.valid) {
				invalidsFields = { ...invalidsFields, [isValid.name]: isValid };
			}
		}
	});
	return invalidsFields;
}

export function validateField(field: field, value: string) {
	let isValid = { valid: true, errorText: '' };
	if (!_.has(field, 'validation')) {
		return isValid;
	}
	return loopValidateTypes(field.props.name, field.validation, value);
}

export function setListOfInvalids(
	invalidFields: { [key: string]: validationProps },
	fieldsValidations: { [key: string]: validationTypes[] | undefined },
	name: string,
	value: string,
	validateData?: Record<validationTypes, string | number | boolean>
) {
	if (_.has(fieldsValidations, name)) {
		const isValid = loopValidateTypes(name, _.get(fieldsValidations, name), value, validateData);
		if (!isValid.valid) {
			return { ...invalidFields, [isValid.name]: isValid };
		} else {
			if (_.has(invalidFields, isValid.name)) {
				return _.omit(invalidFields, isValid.name);
			}
		}
	}
	return invalidFields;
}

const isFloat = (value) => {
	// Check if it's a number and not an integer
	if (typeof value === 'number' && !Number.isNaN(value)) {
		return !Number.isInteger(value);
	}

	// Check if it's a string and matches a valid float pattern
	if (typeof value === 'string') {
		return /^-?\d+(\.\d+)?$/.test(value);
	}

	// For all other types, it's not a float
	return false;
};
